import React from 'react';
import PropTypes from 'prop-types';
import styles from './Chip.module.scss';

function Chip(props) {
  const buildClasses = (props) => {
    let classList = [
      styles.chip,
      props.size,
      props.theme,
    ];
    return classList.join(' ');
  };

  return (
    <div {...props} data-testid="chip-chip" className={ buildClasses(props) }>
      {props.children}
    </div>
  );
}

Chip.propTypes = {
  active: PropTypes.string,
  children: PropTypes.node,
  size: PropTypes.string,
  theme: PropTypes.string,
};

Chip.defaultProps = {
  theme: styles.chipOrange,
  size: styles.chipSizeMedium
};

Chip.THEME = {
  ghostPrimary: styles.chipGhostPrimary,
  gray: styles.chipGray,
  orange: styles.chipOrange,
  orangeAction: styles.chipOrangeAction,
  outlinePrimary: styles.chipOutlinePrimary,
  outlineRed: styles.chipOutlineRed,
  solidPrimary: styles.chipSolidPrimary,
  solidSecondary: styles.chipSolidSecondary,
  text: styles.chipText,
  white: styles.chipWhite,
  whiteOutline: styles.chipWhiteOutline,
};

Chip.SIZE = {
  tiny: styles.chipSizeTiny,
  small: styles.chipSizeSmall,
  medium: styles.chipSizeMedium,
  large: styles.chipSizeLarge,
};

export default Chip;
